var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ShareNetwork',{attrs:{"network":_vm.network,"url":_vm.link,"title":_vm.shareTitle,"description":_vm.post.content}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }